(function(){
  var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
  var HOOK='https://script.google.com/macros/s/AKfycbxvhm6JGHjfl9_nVN11DiOyNpPSc9M9Gq7vpCOSiSydlm6CpPnAywdqmKOULJrmL0UYUw/exec';
  function home(){
    if(!document.body.classList.contains('template-index'))return;
    var secs=[].slice.call(document.querySelectorAll('main .shopify-section'));
    if(secs.length<2)return;
    if(!RM){
      var tk=document.createElement('div');tk.className='fx-ticker';tk.setAttribute('aria-hidden','true');
      var w='<span>No rules<i>&#9670;</i>Define what&rsquo;s NEX<i>&#9670;</i>Stop waiting<i>&#9670;</i>Wear your attitude<i>&#9670;</i></span>';
      tk.innerHTML='<div class="fx-ticker__t">'+w+w+w+w+'</div>';
      secs[0].parentNode.insertBefore(tk,secs[1]);
    }
    var targets=[];
    secs.slice(1).forEach(function(s){
      var root=s.firstElementChild;if(!root)return;
      var kids=[].slice.call(root.children).filter(function(c){var cs=getComputedStyle(c);return cs.position!=='absolute'&&cs.position!=='fixed'&&cs.display!=='none';});
      if(kids.length===1&&kids[0].children.length>1){kids=[].slice.call(kids[0].children).filter(function(c){var cs=getComputedStyle(c);return cs.position!=='absolute'&&cs.display!=='none';});}
      kids.slice(0,8).forEach(function(k,i){k.classList.add('fx');k.style.setProperty('--fd',Math.min(i,4)*90+'ms');targets.push(k);});
    });
    if(RM||!('IntersectionObserver' in window)){targets.forEach(function(t){t.classList.add('fx-in');});}
    else{var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('fx-in');io.unobserve(e.target);}});},{threshold:.08,rootMargin:'0px 0px -8% 0px'});targets.forEach(function(t){io.observe(t);});}
    var copy=document.querySelector('.hero__copy');
    if(copy&&!RM){
      var t=false;function f(){t=false;var y=Math.min(scrollY,innerHeight*1.2),p=Math.min(1,y/(innerHeight*.7));copy.style.translate='0 '+(-y*.22).toFixed(1)+'px';copy.style.opacity=(1-p*.85).toFixed(3);}
      addEventListener('scroll',function(){if(!t){t=true;requestAnimationFrame(f);}},{passive:true});f();
    }
  }
  /* Who is NEX page: repeat the shop button right under the wall */
  function wallCta(){
    var board=document.querySelector('.wl__wall'),b=document.querySelector('.wl__end .wl__btn');
    if(!board||!b)return;
    var d=document.createElement('div');d.style.cssText='text-align:center;margin-top:clamp(10px,3vw,30px)';
    var a=b.cloneNode(true);a.style.marginTop='0';d.appendChild(a);
    board.insertAdjacentElement('afterend',d);
  }
  function contact(){
    var box=document.querySelector('[data-cx]'),fab=document.querySelector('[data-cx-open]');if(!box||!fab)return;
    var last=null;
    function open(){last=document.activeElement;box.classList.add('is-open');box.setAttribute('aria-hidden','false');fab.setAttribute('aria-expanded','true');setTimeout(function(){var x=box.querySelector('.cx__x');x&&x.focus();},60);}
    function close(){box.classList.remove('is-open');box.setAttribute('aria-hidden','true');fab.setAttribute('aria-expanded','false');if(last&&last.focus)last.focus();}
    fab.addEventListener('click',open);
    box.addEventListener('click',function(e){if(e.target.closest('[data-cx-close]'))close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&box.classList.contains('is-open'))close();});
    document.addEventListener('click',function(e){var a=e.target.closest('[data-cx-trigger]');if(a){e.preventDefault();open();}});
    var st=box.querySelector('[data-cx-st]');
    if(/[?&]contact_posted=true/.test(location.search)&&!document.querySelector('.ct')){
      if(st){setTimeout(function(){open();st.textContent=box.getAttribute('data-ok');},400);}
    }
  }
  /* Support messages (pop-up and contact page) go ONLY to our branded support email (Apps Script). No Shopify post, so the team gets exactly one email. */
  function support(){
    var OK='Got it. We’ll hit you back.';
    [].forEach.call(document.querySelectorAll('form.cx__f, form.ct__f'),function(f){
      var hp=document.createElement('input');hp.type='text';hp.name='website';hp.tabIndex=-1;hp.autocomplete='off';hp.setAttribute('aria-hidden','true');hp.style.cssText='position:absolute;left:-9999px;opacity:0;height:0;width:0';f.appendChild(hp);
      var st=f.querySelector('[data-cx-st]');
      if(!st){st=document.createElement('p');st.className='ct__st';st.setAttribute('role','status');f.appendChild(st);}
      var sending=false;
      f.addEventListener('submit',function(e){
        e.preventDefault();
        if(sending)return;
        var b=f.querySelector('button[type=submit]');
        function g(n){var x=f.querySelector('[name="contact['+n+']"]');return x?x.value.trim():'';}
        sending=true;if(b)b.disabled=true;st.textContent='';
        var payload=JSON.stringify({t:'support',n:g('name'),e:g('email'),m:g('body'),s:f.classList.contains('ct__f')?'Contact page':'Hit us up pop-up',hp:hp.value});
        var done=false;
        function ok(){if(done)return;done=true;f.reset();st.textContent=OK;}
        fetch(HOOK,{method:'POST',mode:'no-cors',headers:{'Content-Type':'text/plain;charset=utf-8'},body:payload}).then(ok).catch(function(){
          /* the request may still have reached the server; never re-send through Shopify (that caused the double email) */
          ok();
        }).then(function(){sending=false;if(b)b.disabled=false;});
      });
    });
  }
  function init(){home();wallCta();contact();support();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();